module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAVCAYAAAAnzezqAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4wEWDDo7ia4sRgAAACxJREFUSMdjFLEr/88wgICJYYDBgDtgFIyCUcA4WhCNJoJRMApGC6IRXxABAJxkBWiDgd2eAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./public/img/tampa/ui/icon-menu.png
// module id = 786
// module chunks = 0